import styled, { css } from 'styled-components'
import { fontSize, fontWeight, unit, color } from 'ui/themes/utils'

import P from 'ui/elements/P'
import H2 from 'ui/elements/H2'

export const Section = styled.div`
  position: relative;
`

export const Wrapper = styled.div`
  display: flex;

  flex-direction: column;

  max-height: ${({ maxHeight }) => maxHeight};

  overflow-y: auto;

  gap: ${unit('2')};
  padding: ${unit('4')} ${unit('2')};

  background-color: ${color('Background/Primary')};

  border-radius: ${unit('2')};

  &:has(${Section}) {
    padding-top: 0;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: sticky;
  top: 0;
  left: 0;
  right: 0;

  padding: ${unit('2')} 0;

  text-align: center;

  background-color: ${color('Background/Primary')};
  color: ${color('Text/Tertiary')};

  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('semibold')};

  border-bottom: 1px solid ${color('Misc/Divider')};

  z-index: 10;
`

export const Cleanstate = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: ${({ width }) => width};

  padding: ${unit('12')} 0;

  text-align: center;

  ${H2} {
    font-size: ${unit('4')};
    font-weight: ${fontWeight('semibold')};

    color: ${color('Text/Primary')};
  }

  ${P} {
    margin-bottom: 0;

    font-size: ${unit('3')};

    color: ${color('Text/Tertiary')};
  }
`

export const Timeslots = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: ${unit('2')};

  ${({ columns }) => css`
    grid-template-columns: repeat(${columns}, 1fr);
  `}
`

export const Timeslot = styled.button`
  appearance: none;

  border: none;
  background: transparent;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: ${unit('1')};
  padding: ${unit('2')} ${unit('2')};

  border-radius: ${unit('2')};

  color: ${color('Text/Primary')};

  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('semibold')};

  cursor: pointer;

  &:not(:disabled):hover {
    background-color: ${color('Secondary/Background1')};
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${color('Primary/Background2')};
      &:hover {
        background-color: ${color('Primary/Background2')};
      }
    `}

  ${({ status }) => {
    if (status === 'unavailable') {
      return css`
        color: ${color('Text/Tertiary')};
        font-weight: ${fontWeight('lighter')};
      `
    }
  }}
`

export const AvailabilityIndicator = styled.span`
  width: ${unit('2')};
  height: ${unit('2')};

  border-radius: 50%;

  ${({ status }) => {
    switch (status) {
      case 'available':
        return css`
          background-color: ${color('Success/Base')};
        `
      case 'unavailable':
        return css`
          background-color: ${color('Danger/Base')};
        `
      default:
        return css`
          background: #000000;
          opacity: 0.15;
          animation: pulse 1.5s infinite ease-in-out;
          @keyframes pulse {
            0% {
              opacity: 0.05;
            }
            50% {
              opacity: 0.15;
            }
            100% {
              opacity: 0.05;
            }
          }
        `
    }
  }}
`
